import { Link } from "react-router-dom";
import { Globe } from "@/components/Globe";

export const Footer = () => (
  <footer className="border-t-2 border-[#f4f4f2]" data-testid="site-footer">
    <div className="px-2 pb-6 pt-10">
      <h2
        className="font-display select-none whitespace-nowrap text-center text-[10.5vw] uppercase leading-[1.05] tracking-tight text-[#f4f4f2]"
        data-testid="footer-wordmark"
      >
        Housegemacht
      </h2>
    </div>
    <div className="mx-auto flex max-w-[1100px] flex-wrap items-center justify-between gap-4 border-t-2 border-[#f4f4f2] px-6 py-6">
      <div className="flex items-center gap-2.5">
        <Globe spin className="h-[18px] w-[18px] text-[#f4f4f2]" />
        <span className="font-mono2 text-[11px] font-bold uppercase tracking-[0.14em]">
          © 2026 Housegemacht
        </span>
      </div>
      <span className="font-mono2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#a8a8a4]">
        The Home of House — Köln
      </span>
      <div className="flex items-center gap-6">
        <a
          href="https://www.instagram.com/housegemachtt"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram-link"
          className="font-mono2 text-[11px] font-bold uppercase tracking-[0.14em] underline-offset-4 transition-colors duration-200 hover:text-[#a8a8a4] hover:underline"
        >
          @housegemachtt
        </a>
        <Link
          to="/impressum"
          data-testid="footer-impressum-link"
          className="font-mono2 text-[11px] font-bold uppercase tracking-[0.14em] underline-offset-4 transition-colors duration-200 hover:text-[#a8a8a4] hover:underline"
        >
          Impressum
        </Link>
      </div>
    </div>
  </footer>
);
